module.exports = __webpack_public_path__ + "static/media/farlig.ca3ecb80.svg";